import { useState } from 'react'
import { Offcanvas } from 'react-bootstrap'
import { Menu } from 'lucide-react'
import NavLinks from './NavLinks'

type TopBarProps = {
	rol?: string
	isAdmin?: boolean
	logo?: string
}

export default function TopBar({
	rol,
	isAdmin = false,
	logo = '/images/logotipo-transparente.png',
}: TopBarProps) {
	const [show, setShow] = useState(false)

	return (
		<>
			{/* Barra superior — solo en < lg */}
			<div className="app-topbar d-flex d-lg-none">
				<img src={logo} alt="logo" className="app-topbar__logo" />
				<button
					type="button"
					className="app-topbar__burger"
					onClick={() => setShow(true)}
					aria-label="Abrir menú"
				>
					<Menu size={22} />
				</button>
			</div>

			{/* Menú lateral deslizante */}
			<Offcanvas
				show={show}
				onHide={() => setShow(false)}
				placement="end"
				className="app-offcanvas"
			>
				<Offcanvas.Header className="app-offcanvas__header">
					<img src={logo} alt="logo" style={{ width: '60%', maxWidth: 160 }} />
					<button
						type="button"
						className="btn-close btn-close-white ms-auto"
						onClick={() => setShow(false)}
						aria-label="Cerrar menú"
					/>
				</Offcanvas.Header>

				<Offcanvas.Body className="app-offcanvas__body">
					<NavLinks
						rol={rol}
						isAdmin={isAdmin}
						onNavigate={() => setShow(false)}
					/>
				</Offcanvas.Body>
			</Offcanvas>
		</>
	)
}
